import React from 'react';
import { FiEdit2, FiSave, FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const ProfileSection = ({ 
  title, 
  icon: Icon, 
  isEditing, 
  onEdit, 
  onSave, 
  onCancel, 
  children, 
  hideEdit = false, 
  customActions = null 
}) => (
  <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100 h-full">
    <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
       <h4 className="font-semibold text-gray-900 flex items-center">
          <SafeIcon icon={Icon} className="mr-2 text-indigo-500" />
          {title}
       </h4>
       {!hideEdit && (
         <div className="flex items-center">
            {customActions}
            {isEditing ? (
               <div className="flex space-x-2 ml-2">
                  <button 
                    onClick={onCancel} 
                    className="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 flex items-center"
                  >
                    <SafeIcon icon={FiX} className="w-3 h-3 mr-1" /> ยกเลิก
                  </button>
                  {onSave && (
                    <button 
                      onClick={onSave} 
                      className="px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 flex items-center"
                    >
                      <SafeIcon icon={FiSave} className="w-3 h-3 mr-1" /> บันทึก
                    </button>
                  )}
               </div>
            ) : (
               <button 
                 onClick={onEdit} 
                 className="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 flex items-center"
               >
                 <SafeIcon icon={FiEdit2} className="w-3 h-3 mr-1" /> แก้ไข
               </button>
            )}
         </div>
       )}
    </div>
    <div className="p-6">
       {children}
    </div>
  </div>
);

export default ProfileSection;
